// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'cart';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M4.75 14.047h7.027a1.062 1.062 0 0 0 1.048-.885l1.868-10.979A1.062 1.062 0 0 1 15.74 1.3h.697M6.078 16.172a.266.266 0 0 1 0-.531m0 .531a.266.266 0 0 0 0-.531m5.312.531a.266.266 0 0 1 0-.531m0 .531a.266.266 0 0 0 0-.531' />
    <path d='M13.217 10.86h-8.55a2.125 2.125 0 0 1-2.062-1.61L1.578 5.142a.531.531 0 0 1 .516-.66H14.3' />
  </g>
);

export const viewBox = '0 0 18 18';
